import { TelemetryService } from './services/telemetryService'

window.TelemetryService = TelemetryService